<template>
  <div id="Blank-Page">
    <v-container fluid>
      <v-layout>
        <v-flex xs12>
          <h1>รอบการส่ง</h1>
        </v-flex>       
      </v-layout>
      <v-layout row>
              <v-flex xs3>
                <div class="title pt-3">พัสดุนำส่ง : {{ selected_parcel }}</div>
              </v-flex>
              <v-flex xs9 text-xs-right>
                <v-btn rounded color="info" title="เลือกทั้งหมด" @click="selectAll">
                  <v-icon left>done_all</v-icon>เลือกทั้งหมด
                </v-btn>
                <v-btn rounded color="warning" title="ยกเลิกทั้งหมด" @click="selectNone">
                  <v-icon left>cancel</v-icon>ยกเลิกทั้งหมด
                </v-btn>
                <v-btn rounded color="success" title="ยืนยันนำส่ง" @click="confirm_send_dialog=true">
                  <v-icon left>save</v-icon>ยืนยันนำส่ง
                </v-btn>
              </v-flex>
            </v-layout>
      </v-container>
    <v-container fluid>      
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 v-if="pickedout.length == 0" >
          <v-card>

            <v-card-text class="text-xs-center">
              <v-icon color="orange" x-large>error</v-icon>
              <h2>
            ไม่พบรายการพัสดุที่นำไปส่ง
            </h2>
            </v-card-text>
          </v-card>
          </v-flex>
          <v-flex xs12 v-for="(parcel, index) in pickedout" :key="index">
            <v-card class="mt-3">
              <v-card-title>
                <v-checkbox style="flex: 0"
          v-model="parcel.checked"
        ></v-checkbox>
                <v-icon large left>drafts</v-icon>
                <span
                  class="title font-weight-light"
                >{{ parcel.cust_name }} ({{ parcel.parcel_guid }})</span>
                <v-spacer></v-spacer>
                    <v-btn icon @click="parcel.show_detail = !parcel.show_detail">
                      <v-icon>{{ parcel.show_detail ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                    </v-btn>
              </v-card-title>
              <v-slide-y-transition>
                <div v-show="parcel.show_detail" >
                    <v-card-text >
                      <v-container pa-0>
                        <v-layout row wrap>
                          <v-flex xs12>
                          {{ parcel.cust_name}}
                          </v-flex>
                          <v-flex xs12>
                            {{ parcel.address }}
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions >
                      <v-spacer></v-spacer>
                      <v-btn flat color="red" title="ยกเลิกนำส่ง" @click="parcel.confirm_remove_dialog = true">
                        <v-icon top>remove_circle</v-icon>
                      </v-btn>
        </v-card-actions>
        </div>
              </v-slide-y-transition>
            </v-card>
            <v-dialog v-model="parcel.confirm_remove_dialog" persistent max-width="290">
     
      <v-card>
        <v-card-title class="headline">ยืนยัน</v-card-title>
        <v-card-text>ต้องการยกเลิกการนำส่งหรือไม่</v-card-text>
        <v-card-text> {{ parcel.cust_name}}<br />{{ parcel.address }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" @click="parcel.confirm_remove_dialog = false">ยกเลิก</v-btn>
          <v-btn color="blue darken-1" @click="parcel.confirm_remove_dialog = false; pickoutCancel(parcel.parcel_guid);">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
          </v-flex>
          
          
        </v-layout>
      </v-flex>
    </v-container>

    

    <v-dialog v-model="confirm_send_dialog" persistent max-width="290">    
      <v-card>
        <v-card-title class="headline">ยืนยัน</v-card-title>
        <v-card-text>ต้องการทำการนำส่งพัสดุ ที่ได้เลือกไว้ หรือไม่</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" @click="confirm_send_dialog = false">ยกเลิก</v-btn>
          <v-btn color="blue darken-1" @click="confirm_send_dialog = false; submitPickParcel();">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PackShipService from "@/services/PackShipService";
import authen from "@/store/modules/authen";

export default {
  name: "moveparcel",
  metaInfo: {
    title: "Move Parcel"
  },
  components: {
    // VWidget,
    // MiniStatistic,
    // VCircle,
    // ProfileCard,
    // CircleStatistic,
    // LinearStatistic,
    // BoxChart
  },
  data: () => ({
    pickedout: [],
    confirm_send_dialog: false
  }),
  computed: {

    selected_parcel () {
      if (this.pickedout.length == 0)
        return "";

      let result = this.pickedout.filter(x => x.checked).length + "/" + this.pickedout.length;
      
      return result;
    },
  },
  methods: {
    ...mapActions("app", ["setTitleText"]),
    async fetchPickedOut() {
      this.pickedout = []
      await PackShipService.fetchPickedOutSend(authen.state.userCode)
        .then(res => {
          // console.log(res)
          if (res.success) {
            this.pickedout = this.mergeParcel(res.parcels);
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    mergeParcel(parcels) {
      let result = [];

      parcels.forEach(parcel => {
        
        parcel.show_detail = false
        parcel.confirm_remove_dialog = false
        parcel.checked = false
        result.push(parcel)

        
      });
      return result;
    },
    selectAll() {
      this.pickedout.forEach((parcel) => {
        parcel.checked = true
      }) 
    },
    selectNone() {
      this.pickedout.forEach((parcel) => {
        parcel.checked = false
      }) 
    },
    async submitPickParcel() {

      // pack
      let parcelsSelected = [];
      this.pickedout.forEach((parcel) => {
        if (parcel.checked) {
          parcelsSelected.push(parcel.parcel_guid)
        }
      })

      await PackShipService.submitPickoutConfirm(parcelsSelected)
      .then(res => {
          if (res.data.success) {
            this.fetchPickedOut();
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });

    },
    async pickoutCancel(parcelID) {
      await PackShipService.submitPickedOutCancel(parcelID)
      .then(res => {
          
          if (res.data.success) {
            // console.log(parcelID + "Cancel Success ");
            this.fetchPickedOut();
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    }
  },
  mounted() {},
  created() {
    this.fetchPickedOut();
  }
};
</script>
